/**
 * @format
 */
import { api } from '@/scripts/api';

export const ExchangeRatesService = {
    getAll() {
        const service = '/ms/exchange-rates/v1/currencies';
        return new Promise((resolve, reject) => {
            api.get(service).then(resolve).catch(reject);
        });
    },

    get(isoCode) {
        const service = `/ms/exchange-rates/v1/currencies/${isoCode}`;
        return new Promise((resolve, reject) => {
            api.get(service).then(resolve).catch(reject);
        });
    },

    post(payload) {
        const service = '/ms/exchange-rates/v1/currencies/convert';
        return new Promise((resolve, reject) => {
            api.post(service, payload).then(resolve).catch(reject);
        });
    },
};
